
export enum RebuttalExternalStatusCd {
	APPROVED = 'Approved',
	CUSTOMER_CANCELLED = 'CustomerCancelled',
	DECLINED = 'Declined',
	REBUTTAL_RECEIVED = 'RebuttalReceived',
	UNDER_REVIEW = 'UnderReview'}

